import React from 'react'
import LoadScript from 'components/LoadScript/LoadScript'

class Recaptchas extends React.Component {
	handleRecaptchaLoad() {
		const recaptchas = document.querySelectorAll( '.page-section .frm-g-recaptcha, .content-custom-wrap .frm-g-recaptcha' )

		const recaptchaInterval = setInterval( () => {
			if ( 'undefined' != typeof grecaptcha ) {
				clearInterval( recaptchaInterval )

				Array.from( recaptchas ).forEach( ( recaptcha ) => {
					let recaptchaID = grecaptcha.render( recaptcha, {
						'sitekey': recaptcha.getAttribute( 'data-sitekey' )
					} )
					recaptcha.setAttribute( 'data-rid', recaptchaID )
					recaptcha.classList.remove( 'frm-g-recaptcha' )
				})
			}
		}, 500 )
	}

	render() {
		const recaptchas = document.querySelectorAll( '.page-section .frm-g-recaptcha, .content-custom-wrap .frm-g-recaptcha' )

		if ( recaptchas.length ) {
			return (
				<LoadScript
					src="https://www.google.com/recaptcha/api.js"
					callback={ this.handleRecaptchaLoad }
				/>
			)
		} else {
			return ''
		}
	}
}

export default Recaptchas



// WEBPACK FOOTER //
// ./components/Recaptchas/Recaptchas.jsx